/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Button } from '@lc/legacy/src/Components';

import { booking, url } from 'helpers';
import CalendarBooking from 'components/Booking/CalendarBooking';
import BackButton from 'components/BackButton';
import ViewDetail from 'components/Booking/ViewDetail';
import Availability from 'components/Booking/Availability';
import PeriodSelection from './PeriodSelection';
import RentForm from './RentForm';

const useStyles = makeStyles({
  main: {
    margin: '12px 20px',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  marginSection: {
    marginTop: '14px',
  },
  marginContent: {
    marginTop: '12px',
  },
  hr: {
    border: '0',
    height: '1px',
    backgroundColor: '#a6a6a673',
  },
  gridList: {
    display: 'flex',
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
    overflow: 'auto',
    marginTop: '12px',
  },
  gridListImage: {
    width: '100px',
    margin: '10px',
  },
  priceLabel: {
    backgroundColor: '#f6f6f6',
    color: '#797979',
    padding: '8px 10px',
    borderRadius: '5px',
  },
  dashLi: {
    listStyle: 'none',
    marginLeft: '-16px',
    textTransform: 'capitalize',
  },
  btnCollapse: {
    padding: '0 !important',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const Periods = ({ data, showCalendar, selectedDay, onClose }) => {
  const classes = useStyles();
  const [viewDetail, setViewDetail] = useState();
  const [showTimeTable, setTimeTable] = useState(false);
  const [continueCalendar, setContinueCalendar] = useState(false);
  const [showInitInfo, setShowInitInfo] = useState(true);
  const [showAddress, setShowAddress] = useState(data.clinic === 'Equipamento');
  const [selDay, setSelDay] = useState(selectedDay);
  const [finish, setFinish] = useState(url.getFromQueryString('review') === 'payment');
  const { t } = useTranslation(['booking', 'search']);
  const xsSize = useMediaQuery(useTheme().breakpoints.down('xs'));
  
  window.scrollTo(0, 0);

  if (
    booking.getPeriods(data.id) &&
    Object.keys(booking.getPeriods(data.id)).length === 0 &&
    finish
  ) {
    setFinish(false);
    url.removeFromQueryString('review');
  }

  useEffect(() => {
    if (finish) {
      url.addToQueryString('review', 'payment');
    }
  }, [finish]);

  return (
    <>
      {viewDetail && <ViewDetail detail={viewDetail} close={() => setViewDetail(undefined)} />}

      {showAddress && <RentForm id={data.id} setShowAddress={setShowAddress} onClose={onClose}/>}
      {(!showAddress) && !continueCalendar && showCalendar && showTimeTable === false && (
        <>
          <BackButton onClick={onClose} />
          <div className={classes.main} style={{ marginTop: '0px' }}>
            <Grid container spacing={0}>
              <Grid item xs={12} className={classes.marginSection}>
                <Availability title={t('availability')} data={data} setViewDetail={setViewDetail} />
              </Grid>
              <Grid item xs={12} className={classes.marginSection}>
                <CalendarBooking
                  availability={data.availability[0]}
                  periodType={data.period_type}
                  onDaySelect={day => {
                    setSelDay(day);
                    setTimeTable(true);
                    setFinish(false);
                  }}
                  chosenPeriods={booking.getPeriods(data.id)}
                />
              </Grid>
            </Grid>
          </div>
        </>
      )}
      {!showAddress && continueCalendar && showTimeTable === false && (
        <>
          <BackButton onClick={onClose} />
          <div className={classes.main} style={{ marginTop: '0px' }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                {showInitInfo && (
                  <Availability
                    title={t('Selecione a(s) data(s)')}
                    data={data}
                    setViewDetail={setViewDetail}
                  />
                )}

                {!showInitInfo && (
                  <Typography variant="body2" color="textPrimary">
                    <b>Selecione a data que deseja fazer sua reserva.</b>
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} className={classes.marginSection}>
                <CalendarBooking
                  availability={data.availability[0]}
                  periodType={data.period_type}
                  onDaySelect={day => {
                    setSelDay(day);
                    setTimeTable(true);
                    setContinueCalendar(false);
                  }}
                  chosenPeriods={booking.getPeriods(data.id)}
                />
              </Grid>
              <Grid
                container
                spacing={0}
                justify={xsSize ? 'space-between' : 'flex-end'}
                style={{ marginTop: '30px' }}
              >
                <Button
                  size={xsSize ? 'xs' : ''}
                  color="secondary"
                  variant="outlined"
                  onClick={onClose}
                >
                  Voltar para anúncio
                </Button>
                {!xsSize ? <Box ml={2} /> : null}
                <Button
                  onClick={() => {
                    setFinish(true);
                    setContinueCalendar(false);
                    window.scrollTo(0, 0);

                  }}
                  size={xsSize ? 'xs' : ''}
                  color="secondary"
                  variant="contained"
                >
                  {t('finishBooking')}
                </Button>
              </Grid>
            </Grid>
          </div>
        </>
      )}
      {!showAddress && (showTimeTable || !showCalendar) && !continueCalendar && (
        <div className={classes.main}>
          <PeriodSelection
            data={data}
            items={data.availability}
            period={selDay}
            onSelectMore={() => {
              setShowInitInfo(false);
              setTimeTable(false);
              setContinueCalendar(true);
            }}
            finish={finish}
            setFinish={setFinish}
            onClose={() => {
              if (!showCalendar) onClose();
              if (showTimeTable) setTimeTable(false);
            }}
          />
        </div>
      )}
    </>
  );
};

Periods.propTypes = {
  data: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  selectedDay: PropTypes.instanceOf(Date),
  showCalendar: PropTypes.bool.isRequired
};

Periods.defaultProps = {
  data: undefined,
  selectedDay: new Date()
};

export default Periods;
